<template>
  <svg class="icon icon--grid" width="44px" height="44px" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g class="Grid-Icon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g class="Grid_Icon-OFF">
        <g class="Group" transform="translate(11.000000, 11.000000)" stroke="#FE0000" stroke-width="1.5">
          <rect class="Rectangle" x="1.19187632" y="0.75" width="20.0581237" height="20.5"></rect>
          <path d="M6.5,1 L6.5,21" class="Path-2"></path>
          <path d="M11.5,1 L11.5,21" class="Path-2-Copy"></path>
          <path d="M16.5,1 L16.5,21" class="Path-2-Copy-2"></path>
          <g class="Group-2" transform="translate(11.500000, 11.000000) rotate(-270.000000) translate(-11.500000, -11.000000) translate(6.000000, 1.000000)">
            <path d="M0.5,0 L0.5,20" class="Path-2"></path>
            <path d="M5.5,0 L5.5,20" class="Path-2-Copy"></path>
            <path d="M10.5,0 L10.5,20" class="Path-2-Copy-2"></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  export default{
    data(){
      return{}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/icons/Grid.vue